import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { PhoneVerifyPage } from "@/features/onboarding/pages/phone-verify-page";

export const Route = createFileRoute("/onboarding/_guarded/phone-verify")({
	head: () => pageTitle("Your Mobile Phone Number"),
	component: PhoneVerifyPage,
});
